import React from 'react';

const VideosPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-slate-800 to-slate-700">
      {/* Navigation */}
      <nav className="bg-black/80 backdrop-blur-md border-b-2 border-gradient-to-r from-yellow-400 via-orange-500 to-yellow-400">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center space-x-3 ml-0">
              <div className="bg-black/20 backdrop-blur-sm rounded-xl p-1 border border-yellow-400/30">
                <img 
                  src="https://static.readdy.ai/image/f83f5cd629da4d80734129e80e4e4145/4a7f8b54088d811b1f1eaf12115718e6.jpeg" 
                  alt="ESPECTÁCULOS BRONCHÚ Logo" 
                  className="h-14 w-14 rounded-lg shadow-lg object-cover"
                />
              </div>
              <div>
                <h1 className="text-xl font-black text-white font-sans tracking-widest drop-shadow-2xl" style={{fontFamily: 'Inter, system-ui, sans-serif', letterSpacing: '0.2em', textShadow: '2px 2px 4px rgba(0,0,0,0.8)'}}>
                  ESPECTÁCULOS BRONCHÚ
                </h1>
                <p className="text-xs text-yellow-400 font-light tracking-widest" style={{letterSpacing: '0.25em'}}>
                  L'ART DEL FOC I EL SO
                </p>
              </div>
            </div>

            {/* Navigation Menu */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                INICIO
              </a>
              <a href="/pirotecnica" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                PIROTÉCNICA
              </a>
              <a href="/eventos" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                EVENTOS
              </a>
              <a href="/videos" className="text-yellow-400 border-b-2 border-yellow-400 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                VIDEOS
              </a>
              <a href="/calendario" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                CALENDARIO
              </a>
              <a href="/merchandising" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                MERCHANDISING
              </a>
              <a href="/nosotros" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                NOSOTROS
              </a>
              <a href="/contacto" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                CONTACTO
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative py-32">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=video%20camera%20filming%20professional%20fireworks%20display%2C%20cinematography%20equipment%2C%20professional%20video%20production%2C%20Valencia%20mascleta%20being%20recorded%2C%20cinematic%20angle%2C%20media%20production&width=1920&height=800&seq=45&orientation=landscape')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-gray-900/60 via-gray-900/40 to-gray-900/60"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-7xl font-bold text-white mb-6 tracking-wider drop-shadow-2xl">
            GALERÍA DE<br />
            <span className="bg-gradient-to-r from-yellow-400 via-orange-400 to-red-500 bg-clip-text text-transparent">
              ESPECTÁCULOS
            </span>
          </h1>
          
          <p className="text-2xl text-yellow-400 mb-12 font-serif tracking-wider">
            REVIVE NUESTROS MEJORES MOMENTOS
          </p>
        </div>
      </section>

      {/* Contenido Vacío */}
      <section className="py-20 bg-gradient-to-b from-slate-700 to-slate-600">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center py-20">
            <div className="mb-8">
              <div className="w-24 h-24 bg-yellow-400/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-video-add-line text-4xl text-yellow-400"></i>
              </div>
              <h2 className="text-4xl font-serif font-bold text-white tracking-wider mb-4">
                PRÓXIMAMENTE
              </h2>
              <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
                Estamos preparando una increíble galería de videos con nuestros mejores espectáculos de pirotécnica y eventos
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-yellow-400/30">
                <div className="w-16 h-16 bg-yellow-400/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-fire-line text-2xl text-yellow-400"></i>
                </div>
                <h3 className="text-white font-bold text-lg mb-2">PIROTÉCNICA</h3>
                <p className="text-gray-300">Videos de nuestras mascletas y castillos más espectaculares</p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-cyan-400/30">
                <div className="w-16 h-16 bg-cyan-400/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-music-line text-2xl text-cyan-400"></i>
                </div>
                <h3 className="text-white font-bold text-lg mb-2">EVENTOS</h3>
                <p className="text-gray-300">Grabaciones de nuestros mejores eventos y celebraciones</p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-orange-400/30">
                <div className="w-16 h-16 bg-orange-400/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-camera-line text-2xl text-orange-400"></i>
                </div>
                <h3 className="text-white font-bold text-lg mb-2">BEHIND THE SCENES</h3>
                <p className="text-gray-300">Tras las cámaras de nuestros espectáculos</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-t from-slate-800 to-gray-700 py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center">
            <h3 className="text-white text-2xl font-serif font-bold mb-4">
              ¿QUIERES QUE TU EVENTO APAREZCA AQUÍ?
            </h3>
            <p className="text-gray-300 mb-8">
              Contacta con nosotros y crearemos un espectáculo digno de ser recordado
            </p>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed mb-8">
              17 años capturando momentos únicos e inolvidables
            </p>
            <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-6">
              <a href="/contacto" className="bg-yellow-400 text-black px-8 py-4 rounded-lg font-bold text-lg tracking-wider hover:scale-105 transition-transform duration-300 cursor-pointer whitespace-nowrap">
                SOLICITAR PRESUPUESTO
              </a>
              <a href="/pirotecnica" className="border-2 border-yellow-400 text-yellow-400 px-8 py-4 rounded-lg font-bold text-lg tracking-wider hover:bg-yellow-400 hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap">
                VER SERVICIOS
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default VideosPage;
